import React, { useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import MainLayout from "../../../../layouts/MainLayout";
import "../../../../assets/styles/custom-styles.css";
import useNotification from "../../../../hooks/useNotification";
import DetailsSectionRenderer from "../../../../components/DetailsSectionRenderer";
import useBaseService from "../../../../hooks/services/useBaseService";
import { detailsLocationFields } from "../../../../constants/forms/locationFields";
import { entities } from "../../../../constants/entities";
import PageHeader from "../../../../components/PageHeader";
import useQueryWithLoader from "../../../../hooks/useQueryWithLoader";

const DetailsCustomerLocationPage = () => {
  const navigate = useNavigate();
  const { id, addressId, locationId } = useParams();
  const location = useLocation();
  const { showNotification } = useNotification();
  const { getByColumn: baseServiceGetByColumn } = useBaseService(navigate);

  const {
    data: locationData,
    isLoading: isLoadingLocation,
    isFetching: isFetchingLocation,
  } = useQueryWithLoader({
    queryKey: ["customerLocationDetails", id, addressId, locationId],
    queryFn: async () => {
      const response = await baseServiceGetByColumn(
        entities.customers.customerAddressLocationUpdate(
          id,
          addressId,
          locationId,
        ),
      );
      return response.result;
    },
    enabled: !!id && !!addressId && !!locationId,
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (location.state?.message) {
      showNotification(location.state.type, location.state.message);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, showNotification, navigate, location.pathname]);

  const isPageLoading = isLoadingLocation || isFetchingLocation;

  return (
    <MainLayout selectedCompany="ALUCOM">
      <PageHeader
        title="Detalhes da Localização"
        showBackButton={true}
        backUrl={`/aluguel/clientes/${id}/endereco/${addressId}/localizacoes`}
      />
      <div className="container-fluid p-1">
        {locationData ? (
          <DetailsSectionRenderer
            formData={locationData}
            sections={detailsLocationFields}
            readOnly
          />
        ) : isPageLoading ? (
          <div className="text-center py-4">
            Carregando detalhes da localização...
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            Não foi possível carregar os detalhes da localização.
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default DetailsCustomerLocationPage;
